<template>
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M8.841 1.309 10 2.467l1.159-1.158M11.159 18.691l-1.16-1.159-1.158 1.16M5.833 8.842a1.159 1.159 0 0 1 2.318 0c0 .375-.127.74-.362 1.032L5.833 12.32h2.318M14.056 12.318V7.682l-1.738 2.897-1.739-2.897v4.636"
    stroke="currentColor"
    stroke-width="1.458"
    stroke-linecap="round"
    stroke-linejoin="round"
  /></svg>
</template>
